import { OVERSELLABLE_STATUSES } from "../config/const";

export function isOversellableProduct(
  itemStatus: string = "",
  flags: string[] = [],
) {
  if (itemStatus && OVERSELLABLE_STATUSES.includes(itemStatus)) {
    return true;
  }

  return flags.some((flag) => OVERSELLABLE_STATUSES.includes(flag));
}
